import React from "react";
import { LicenseName } from "@/data/license.data";
import { convertVoiceLicenseManager } from "@/services/license/license-managers/convert-voice-license-manager";
import LicenseLimitedModal from "@/components/modal/license-limited-modals/license-limited-modal";

type ConvertsLimitedModalProps = {
  licenseName: LicenseName;
  shouldNavigateToPricing?: boolean;
};

const ConvertsCountLimitedModal = ({
  licenseName,
  shouldNavigateToPricing,
}: ConvertsLimitedModalProps) => {
  const convertsCount =
    convertVoiceLicenseManager.serviceUsingCountLimiter.getPlanLimit(
      licenseName,
    );

  return (
    <LicenseLimitedModal
      licenseName={licenseName}
      upgradeToMessage={"generate unlimited number of AI covers"}
      allowsMessage={`${licenseName} version allows you to generate only ${convertsCount} cover${convertsCount > 1 ? "s" : ""} per month.`}
      shouldNavigateToPricing={shouldNavigateToPricing}
    />
  );
};

export default ConvertsCountLimitedModal;
